import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Cell, InputBar, Spacer, Validation } from '@vinted/web-ui';
import { ResponseCode } from 'data/api/response-codes';
import { UiState } from 'constants/ui';
import { COMMENT_CHAR_LIMIT } from 'state/user-feedback/constants';
import * as selectors from 'state/user-feedback/selectors';
import { actions } from 'state/user-feedback/slice';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const mapStateToProps = (state, _ref) => {
  let {
    id
  } = _ref;
  return {
    comment: selectors.getCommentById(state, id),
    uiState: selectors.getFeedbackUiState(state, id),
    error: selectors.getFeedbackError(state, id)
  };
};

const mapActionsToProps = {
  feedbackToggleCancel: actions.feedbackToggleCancel,
  feedbackCommentCreateRequest: actions.feedbackCommentCreateRequest,
  feedbackCommentEditRequest: actions.feedbackCommentEditRequest
};
const connector = connect(mapStateToProps, mapActionsToProps);

class CommentInput extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      text: this.props.comment ? this.props.comment.text : '',
      error: null
    });

    _defineProperty(this, "handleChange", event => {
      this.setState({
        text: event.currentTarget.value
      });
    });

    _defineProperty(this, "handleValueClear", () => {
      this.setState({
        text: ''
      });
    });

    _defineProperty(this, "handleCancel", () => {
      const {
        id,
        feedbackToggleCancel
      } = this.props;
      return feedbackToggleCancel({
        feedbackId: id
      });
    });

    _defineProperty(this, "handleEdit", () => {
      const {
        text,
        error
      } = this.state;
      const {
        id,
        comment,
        feedbackCommentCreateRequest,
        feedbackCommentEditRequest,
        intl
      } = this.props;

      if (!text) {
        this.setState({
          error: intl.formatMessage({
            id: 'user.feedback.empty_message'
          })
        });
        return;
      }

      if (error) this.setState({
        error: null
      });
      const action = comment ? feedbackCommentEditRequest : feedbackCommentCreateRequest;
      action({
        feedbackId: id,
        comment: this.state.text
      });
    });
  }

  renderValidation() {
    const {
      error: localError
    } = this.state;
    const {
      uiState,
      error
    } = this.props;
    let message;

    if (localError) {
      message = localError;
    } else {
      if (uiState !== UiState.Failure || !(error !== null && error !== void 0 && error.errors) || error.code !== ResponseCode.ValidationError) {
        return null;
      }

      const failingField = error.errors.find(_ref2 => {
        let {
          field
        } = _ref2;
        return field === 'comment';
      });
      if (!failingField) return null;
      message = failingField.value;
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(Validation, {
        text: message,
        theme: "warning"
      })]
    });
  }

  render() {
    const {
      uiState
    } = this.props;
    return /*#__PURE__*/_jsxs(Cell, {
      children: [/*#__PURE__*/_jsx(InputBar, {
        placeholder: "",
        name: "create-comment",
        value: this.state.text,
        onChange: this.handleChange,
        onValueClear: this.handleValueClear,
        isMultiline: true,
        maxRows: 1,
        max: COMMENT_CHAR_LIMIT
      }), this.renderValidation(), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(Button, {
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "user.feedback.cancel"
        }),
        size: Button.Size.Medium,
        styling: Button.Styling.Flat,
        inline: true,
        onClick: this.handleCancel
      }), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical
      }), /*#__PURE__*/_jsx(Button, {
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "user.feedback.reply"
        }),
        size: Button.Size.Medium,
        styling: Button.Styling.Filled,
        inline: true,
        onClick: this.handleEdit,
        isLoading: uiState === UiState.Pending
      })]
    });
  }

}

export const CommentInputWithIntl = injectIntl(CommentInput);
export default connector(CommentInputWithIntl);